import { useMemo } from "react";
import type { HistogramItem } from "../shared-histogram";
import { SharedHistogram } from "../shared-histogram";

interface StreamHistogramProps {
  // Matches the Relay fragment shape passed by StakeholderRow (readonly array).
  stream: {
    id: string;
    flows: ReadonlyArray<{
      amount: number;
      kind: string;
      date: string;
    }>;
  };
  ratio?: number;
}

export default function StreamHistogram({
  stream,
  ratio,
}: StreamHistogramProps) {
  const items: HistogramItem[] = useMemo(
    () =>
      stream.flows.map((f, i) => ({
        // Flows might not have IDs in your fragment, so we generate a composite key
        id: `${stream.id}-flow-${i}`,
        amount: f.amount,
        date: f.date,
        label: f.kind,
      })),
    [stream]
  );

  return (
    <SharedHistogram
      items={items}
      ratio={ratio}
      title="normalized flows"
      colorClass="bg-emerald-500" // Distinct color for flows
    />
  );
}
